import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { FiArrowLeft } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import './Terms.css';

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="terms-section">
      <div className="terms-container">
        <div className="terms-header">
          <Link to="/" className="back-link">
            <FiArrowLeft /> Voltar para o início
          </Link>
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            Termos e Condições de Uso – CSG TV
          </motion.h1>
        </div>

        <motion.div 
          className="terms-content"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <p className="intro-text">
            Ao acessar, instalar ou utilizar o aplicativo <strong>CSG TV</strong>, você concorda integralmente com os presentes <strong>Termos e Condições de Uso</strong>. Caso não concorde com qualquer parte destes termos, recomendamos que não utilize o serviço.
          </p>

          <div className="term-block">
            <h2>1. Sobre o CSG TV</h2>
            <p>
              O <strong>CSG TV</strong> é um aplicativo de entretenimento digital voltado para a exibição de conteúdos audiovisuais, como <strong>filmes, séries e conteúdos relacionados</strong>, disponibilizados por meio de <strong>assinatura digital</strong>.
            </p>
            <p>
              O serviço pode ser acessado por dispositivos compatíveis, incluindo <strong>Desktop e dispositivos móveis</strong>, conforme versões disponibilizadas oficialmente.
            </p>
          </div>

          <div className="term-block">
            <h2>2. Conta e Assinatura</h2>
            <ul>
              <li>O acesso ao CSG TV é realizado mediante <strong>assinatura digital</strong>.</li>
              <li>A assinatura é <strong>pessoal e intransferível</strong>.</li>
              <li>É de responsabilidade do usuário manter a segurança de seus dados de acesso.</li>
              <li>O compartilhamento de contas pode resultar em <strong>suspensão ou encerramento da assinatura</strong>, sem direito a reembolso.</li>
            </ul>
          </div>

          <div className="term-block">
            <h2>3. Política de Reembolso</h2>
            <p>
              Por se tratar de um <strong>produto digital de assinatura</strong>, o <strong>CSG TV NÃO realiza reembolsos</strong>, totais ou parciais, após a liberação do acesso.
            </p>
            <p>Ao efetuar a assinatura, o usuário reconhece que:</p>
            <ul>
              <li>O serviço é entregue <strong>imediatamente após a confirmação do pagamento</strong>;</li>
              <li>Não é possível devolver, cancelar ou estornar o acesso já concedido;</li>
              <li>A ausência de uso do serviço não gera direito a reembolso.</li>
            </ul>
            <p>Essa política está em conformidade com produtos digitais de acesso contínuo.</p>
          </div>

          <div className="term-block">
            <h2>4. Desempenho, Lentidão e Conexão</h2>
            <p>
              O <strong>CSG TV</strong> possui um sistema otimizado e funcional. No entanto, o desempenho do serviço pode variar de acordo com fatores externos, tais como:
            </p>
            <ul>
              <li>Qualidade da conexão de internet do usuário;</li>
              <li>Estabilidade do provedor de internet;</li>
              <li>Limitações do dispositivo utilizado;</li>
              <li>Uso de VPNs, proxies ou bloqueadores;</li>
              <li>Tráfego elevado na rede do usuário.</li>
            </ul>
            <p>
              O CSG TV <strong>não se responsabiliza por lentidão, travamentos ou falhas</strong> decorrentes de problemas de conexão, dados móveis, Wi-Fi instável ou limitações do dispositivo do usuário.
            </p>
          </div>

          <div className="term-block">
            <h2>5. Disponibilidade do Serviço</h2>
            <ul>
              <li>O CSG TV busca oferecer <strong>alta disponibilidade</strong>, porém podem ocorrer <strong>manutenções, atualizações ou instabilidades temporárias</strong>.</li>
              <li>Interrupções pontuais não geram direito a reembolso ou compensações.</li>
              <li>Funcionalidades, conteúdos ou recursos podem ser alterados, atualizados ou removidos sem aviso prévio.</li>
            </ul>
          </div>

          <div className="term-block">
            <h2>6. Conteúdo</h2>
            <ul>
              <li>O catálogo do CSG TV pode sofrer alterações ao longo do tempo.</li>
              <li>Não garantimos a disponibilidade permanente de títulos específicos.</li>
              <li>O conteúdo exibido é apenas para <strong>uso pessoal e não comercial</strong>.</li>
            </ul>
            <p>É proibido:</p>
            <ul>
              <li>Gravar, copiar, redistribuir ou revender o conteúdo;</li>
              <li>Utilizar o serviço para fins ilegais;</li>
              <li>Tentar burlar sistemas de segurança ou acesso.</li>
            </ul>
          </div>

          <div className="term-block">
            <h2>7. Uso Indevido</h2>
            <p>O usuário concorda em não:</p>
            <ul>
              <li>Explorar falhas do sistema;</li>
              <li>Utilizar softwares de terceiros para manipular o aplicativo;</li>
              <li>Compartilhar acessos publicamente;</li>
              <li>Praticar qualquer atividade que comprometa a estabilidade do serviço.</li>
            </ul>
            <p>
              O descumprimento pode resultar em <strong>bloqueio imediato da conta</strong>, sem reembolso.
            </p>
          </div>

          <div className="term-block">
            <h2>8. Limitação de Responsabilidade</h2>
            <p>O CSG TV não se responsabiliza por:</p>
            <ul>
              <li>Perdas de dados locais;</li>
              <li>Problemas causados por terceiros;</li>
              <li>Incompatibilidades com dispositivos não suportados;</li>
              <li>Expectativas não atendidas quanto a conteúdos específicos.</li>
            </ul>
            <p>
              O uso do serviço é de <strong>inteira responsabilidade do usuário</strong>.
            </p>
          </div>

          <div className="term-block">
            <h2>9. Alterações dos Termos</h2>
            <p>
              Os Termos e Condições podem ser atualizados a qualquer momento. O uso contínuo do aplicativo após alterações implica na <strong>aceitação automática dos novos termos</strong>.
            </p>
          </div>

          <div className="term-block">
            <h2>10. Suporte</h2>
            <p>
              O suporte é oferecido pelos canais oficiais do CSG TV. O prazo de resposta pode variar conforme demanda e complexidade do atendimento.
            </p>
          </div>

          <div className="term-block">
            <h2>11. Disposições Finais</h2>
            <p>
              Estes termos são regidos pelas leis aplicáveis. Qualquer dúvida relacionada a estes Termos e Condições deverá ser esclarecida antes da assinatura.
            </p>
            <p className="highlight-text">
              Ao utilizar o <strong>CSG TV</strong>, você declara que leu, compreendeu e concorda com todos os termos aqui descritos.
            </p>
          </div>

          <div className="terms-footer-note">
            <p><strong>CSG TV – Entretenimento digital de forma simples e moderna.</strong></p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Terms;
